import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import ImageComponent from "../ImageComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import TextComponent from "../TextComponent";
import InnerSectionComponent from "../InnerSectionComponent";
import FooterComponent from "../FooterComponent";
import ButtonComponent from "../ButtonComponent";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  image: ImageComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  text: TextComponent,
  inner_section: InnerSectionComponent,
  footer: FooterComponent,
  Button: ButtonComponent,
};
